export const LIB_VERSION = '1.319.0'; // autogenerated
